import { render } from "./KobiSphere.vue?vue&type=template&id=85141e4e"
import script from "./KobiSphere.vue?vue&type=script&lang=js"
export * from "./KobiSphere.vue?vue&type=script&lang=js"

import "./KobiSphere.vue?vue&type=style&index=0&id=85141e4e&lang=css"
script.render = render

export default script